import React from 'react';
import { useIntl } from 'react-intl';
import { Survey } from '../../../../common/src/domain/survey/survey/surveyTableSchema';
import { useTranslate } from '../../mixins/translate/translate';
import { fetchGet } from '../../store/fetch';
import { EditPanelButton, EditPanelButtons, EditPanelCell, EditPanelRow, EditPanelSelect, ISelectOption, PanelBody } from '../elements';

interface ISelectModel3dSurveyProps {
    surveyId: string;
    objectId: string;
    onUpdated: () => void;
    model3dSurveyId: string | null;
    onChange: (model3dSurveyId: string | null) => void;
    onSave: () => void;
}

type Model3dSurvey = Pick<Survey, 'id' | 'description' | 'surveryedOn'>;

export function SelectModel3dSurvey(props: ISelectModel3dSurveyProps) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { formatDate } = useIntl();
    const translate = useTranslate();

    const [model3dSurveyOptions, setModel3dSurveyOptions] = React.useState<ISelectOption[]>([]);

    async function loadData() {
        const response = await fetchGet('/api/surveys', { objectId: props.objectId, inspectionStandardType: 'model3d' });
        const options = response.json.items.map((i: Model3dSurvey) => ({
            value: i.id,
            text: `${i.surveryedOn ? formatDate(i.surveryedOn) : ''} ${i.description}`,
        }));

        setModel3dSurveyOptions([{ value: '', text: translate('common.select') }, ...options]);
    }

    React.useEffect(() => {
        void loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleChange(value: string) {
        if (value === '') {
            props.onChange(null);
        } else {
            props.onChange(value);
        }
    }

    return (
        <PanelBody isForm={true}>
            <EditPanelRow>
                <EditPanelCell rowCount={6}>
                    <EditPanelSelect
                        name="pointCloudUrlType"
                        value={props.model3dSurveyId}
                        handleChange={handleChange}
                        options={model3dSurveyOptions}
                    />
                </EditPanelCell>
            </EditPanelRow>
            <EditPanelButtons>
                <EditPanelButton small={true} text={translate('common.save')} onClick={props.onSave} primary />
            </EditPanelButtons>
        </PanelBody>
    );
}
